// extracted by mini-css-extract-plugin
export default {"root":"full_height_number_root__IbwJC","root2":"full_height_number_root2__Yrhnc"};